import { IHasETag } from './etag.model';
import { IList } from './list.model';

export enum ModesReceptionCarpaSortableCols {
	libelle = 'libelle',
	actifEmdf = 'actifEmdf',
	actifEcarpa = 'actifEcarpa',
	modeParDefaut = 'modeParDefaut'
}

export interface IModeReception extends IHasETag {
	id: string;
	libelle: string;
	code?: string;
	carpaId?: string;
	modeParDefaut: boolean;
	actifEcarpa: boolean;
	actifEmdf: boolean;
	parentModeReceptionId?: string;
}

export interface IModesReceptionList extends IList<IModeReception> {}
